import React from "react"
import styled from "@emotion/styled"
import Image from "../global/Image"

import ButtonLink from "../global/ButtonLink"
import ButtonAnchor from "../global/ButtonAnchor"

import User1 from "../../images/user/user-thumbnail-1.png"
import User2 from "../../images/user/user-thumbnail-2.png"
import User3 from "../../images/user/user-thumbnail-3.png"

import Cursor1 from "../../images/cursors/cursor-1.svg"
import Cursor2 from "../../images/cursors/cursor-2.svg"
import Cursor3 from "../../images/cursors/cursor-3.svg"

const Outer = styled.section`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, 500px) minmax(400px, 700px)
    minmax(32px, auto);
  width: 100%;
  padding: 96px 0;
  gap: 64px;
  align-items: center;
  background: ${props =>
    props.backgroundColorOverride
      ? props.backgroundColorOverride
      : "transparent"};
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    padding: 96px 32px;
    grid-template-columns: 1fr;
  }
`

const Title = styled.h1`
  span {
    font-weight: 800;
  }
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    font-size: 2.4rem;
  }
`
const Cursor = styled.img`
  width: 40px;
  position: absolute;
  animation-direction: alternate;
  bottom: 10%;
  left: 30%;
  opacity: 0;
  animation: fadeScaleUp 1s;
  animation-fill-mode: forwards;
  transform-origin: center;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    width: 20px;
  }
  &:nth-of-type(2) {
    top: 50%;
    left: 50%;
  }
  &:nth-of-type(1) {
    top: 20%;
    left: 30%;
  }
  @keyframes fadeScaleUp {
    0% {
      opacity: 0;
      transform: scale(0) translate(0, 20px);
    }
    100% {
      opacity: 1;
      transform: scale(1) translate(0, 0);
    }
  }
`
const User = styled.img`
  position: absolute;
  width: 120px;
  height: 120px;
  top: -24px;
  left: 30%;
  box-shadow: 0 30px 60px -12px rgba(50, 50, 93, 0.25),
    0 18px 36px -18px rgba(0, 0, 0, 0.3);
  opacity: 0;
  border-radius: 16px;
  margin: 0;
  animation: fadeUp 1s;
  animation-fill-mode: forwards;
  animation-delay: 0.9s;
  &:nth-of-type(5) {
    top: 30%;
    left: -24px;
    animation-delay: 0.3s;
  }
  &:nth-of-type(6) {
    top: unset;
    bottom: -48px;
    left: 40%;
    animation-delay: 0.6s;
  }
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    width: 80px;
    height: 80px;
  }
  @keyframes fadeUp {
    0% {
      opacity: 0;
      transform: translate(0, 20px);
    }
    100% {
      opacity: 1;
      transform: translate(0, 0);
    }
  }
`
const Content = styled.div`
  grid-column: 2;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-column: unset;
  }
`
const ButtonGrid = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  gap: 16px;
`

const Wireframe = styled.div`
  grid-column: 3 / 5;
  border-radius: 16px;
  width: 100%;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    width: 100%;
    justify-content: stretch;
    grid-column: unset;
  }
`

const WireframeContainer = styled.div`
  max-width: 960px;
  position: relative;
  box-shadow: 0 30px 60px -12px rgba(50, 50, 93, 0.25),
    0 18px 36px -18px rgba(0, 0, 0, 0.1);
  border-radius: 32px;
  opacity: 0;
  animation: fadeLeft 1s;
  animation-fill-mode: forwards;
  @keyframes fadeLeft {
    0% {
      opacity: 0;
      transform: translate(20px, 0);
    }
    100% {
      opacity: 1;
      transform: translate(0, 0);
    }
  }
`
const Text = styled.div`
  p {
    margin-bottom: 0.5rem;
  }
  li {
    margin: 0;
  }
`
const Eyebrow = styled.p`
  margin-bottom: 0.5rem;
  color: #718096;
`

export default function AnimatedHero({
  eyebrow,
  title,
  description,
  image,
  tellMeMore,
}) {
  return (
    <Outer>
      <Content>
        {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
        <Title>{title}</Title>
        <Text>{description}</Text>
        <ButtonGrid>
          {tellMeMore && (
            <ButtonAnchor
              href="#tell"
              backgroundColorOverride={props => props.theme.primary}
            >
              Tell me more
            </ButtonAnchor>
          )}
          <ButtonLink
            buttonStyle="ghost"
            backgroundColorOverride={props => props.theme.primary}
            to="/contact/"
          >
            Get in touch
          </ButtonLink>
        </ButtonGrid>
      </Content>
      <Wireframe>
        <WireframeContainer>
          <Image src={image} alt="Basecamp Screenshot" />
          <Cursor src={Cursor1} alt="A mouse cursor" />
          <Cursor src={Cursor2} alt="A mouse cursor" />
          <Cursor src={Cursor3} alt="A mouse cursor" />
          <User src={User1} alt="A user testing user" />
          <User src={User2} alt="A user testing user" />
          <User src={User3} alt="A user testing user" />
        </WireframeContainer>
      </Wireframe>
    </Outer>
  )
}
